var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-45a)" },
      React.createElement("path", { d: "M4.5 16L12 8.5L19.5 16", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-45a" },
        React.createElement("path", { fill: "#fff", transform: "rotate(180 12 12)", d: "M0 0H24V24H0z" })
      )
    )
  );
});